<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrightx"><a id="page_ii"></a>First published in 2021 by Birlinn Ltd</p>
<p class="copyright">West Newington House</p>
<p class="copyright">10 Newington Road</p>
<p class="copyright">Edinburgh</p>
<p class="copyright">EH9 1QS</p>
<p class="copyright1">Text © Peter Evans, 2021</p>
<p class="copyright">Photographs © Peter Evans unless otherwise acknowledged</p>
<p class="copyright1">ISBN: 978 1 78027 590 1<br/>eBook ISBN 978 1 78885 209 8</p>
<p class="copyright1">The moral right of Peter Evans to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copyright1">All rights reserved. No part of this publication may be reproduced, stored or transmitted in any form without the express written permission of the publisher.</p>
<p class="copyrightb">Printed in China through World Print Ltd</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?a7c3ef42